import React from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/react/daygrid'
import nlLocale from '@fullcalendar/react/locales/nl'
import classicThemePlugin from '@fullcalendar/react/themes/classic'
import '@fullcalendar/react/skeleton.css'
import '@fullcalendar/react/themes/classic/theme.css'
import '@fullcalendar/react/themes/classic/palette.css'

const ReactCalendar = (props) => {
    const datums = props.datums;

    const handleDateClick = (e) => { // bind with an arrow function
      console.log(e.event.title);
    }

    return (
      <FullCalendar
        plugins={[ dayGridPlugin, classicThemePlugin ]}
        locale={nlLocale}
        className="fc"
        toolbarClass="fc-header-toolbar"
        toolbarTitleClass="fc-toolbar-title"
        viewClass="fc-scrollgrid"
        buttonClass={(info) => `fc-${info.name}-button`}
        dayHeaderInnerClass="fc-col-header-cell-cushion"
        dayCellClass={(info) => info.isToday ? 'fc-day-today' : info.isPast ? 'fc-day-past' : 'fc-day-future'}
        dayCellTopInnerClass="fc-daygrid-day-number"
        inlineWeekNumberClass="fc-daygrid-week-number"
        eventTitleClass="fc-event-title"
        weekNumbers={true}
        firstDay={1}
        headerToolbar={{ left: 'title', center: '', right: 'today prev,next' }}
        initialView="dayGridMonth"
        events={ datums }
        eventClick={(e) => handleDateClick(e)}
      />
    )
}

export default ReactCalendar;